import React from "react";
import "./JobCard.css";
import axios from "axios";
import { mainurl } from "../../actions/mainurl";
import { toast } from "react-toastify";

function JobCard({ val, setDeleteSuccess }) {
  const baseUrl = mainurl;

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${baseUrl}/jobpost/delete-job/${id}`, {
        withCredentials: true,
      });
      toast.success("successfully deleted");
      setDeleteSuccess(id);
    } catch (error) {}
  };

  const getContent = (data) => {
    return <div dangerouslySetInnerHTML={{ __html: data }} />;
  };

  return (
    <div className="jobpostcard">
      <div className="jobpostcard_heading">{`${val.jobRole}`}</div>
      <div className="jobpostcard_content_div">
        <div className="jobpostcard_content">
          Job Role :- {`${val.jobRole}`}
        </div>
        <div className="jobpostcard_content">
          Location :- {`${val.location}`}
        </div>
        <div className="jobpostcard_content">
          Experience :- {`${val.experience}`}
        </div>
        <div className="jobpostcard_content">
          Position :- {`${val.postion}`}
        </div>
        <div className="jobpostcard_content">
          Required Skills :- {getContent(val.requiredSkill)}
        </div>
        <div className="jobpostcard_content">
          Key Responsibilities :- {getContent(val.keyresponse)}
        </div>
        <button className="delete_jobcard_btn" onClick={() => handleDelete(val._id)}>
          delete
        </button>
      </div>
    </div>
  );
}

export default JobCard;
